<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          small
          color="primary"
          class="ml-2"
          v-on="on"
          @click.stop="openDialog"
          ><v-icon small>mdi-cloud-download</v-icon></v-btn
        >
      </template>
      <span>Export Chart</span>
    </v-tooltip>
    <v-dialog v-model="showDialog" max-width="400">
      <validation-observer ref="form" v-slot="{ invalid }">
        <v-card>
          <v-card-title>Export Chart</v-card-title>
          <v-card-text>
            <date-picker
              :field="{ label: 'Start Date' }"
              :value="startDate"
              :validations="{ required: true }"
              outlined
              @fieldChange="startDate = $event"
            ></date-picker>
            <date-picker
              :field="{ label: 'End Date' }"
              :value="endDate"
              :validations="{ required: true }"
              outlined
              @fieldChange="endDate = $event"
            ></date-picker>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showDialog = false">Cancel</v-btn>
            <v-btn color="primary" :disabled="invalid" @click="exportChart"
              >Export</v-btn
            >
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-dialog>
  </span>
</template>

<script>
import { downloadFile } from "../../../utils/download-utils";
import { formatDateForFilename } from "../../../utils/format-utils";

// this button only exports the Underschool age category
const UNDERSCHOOL_AGE_CATEGORY_ID = 1;

export default {
  props: ["clientId", "clientName"],
  data() {
    return {
      showDialog: false,
      startDate: null,
      endDate: null,
    };
  },
  methods: {
    openDialog() {
      this.startDate = null;
      this.endDate = null;
      this.$refs.form?.reset();
      this.showDialog = true;
    },
    async exportChart() {
      this.showDialog = false;
      this.$store.commit("uxModule/setShowLoader", true);
      const response = await this.$store.dispatch(
        "clientModule/exportClientChart",
        {
          clientId: this.clientId,
          ageCategoryId: UNDERSCHOOL_AGE_CATEGORY_ID,
          startDate: this.startDate,
          endDate: this.endDate,
        }
      );
      let snackbarMsg;
      if (response?.success) {
        const fileName = `${this.clientName} Chart ${formatDateForFilename(
          this.startDate
        )} to ${formatDateForFilename(this.endDate)}.zip`;
        await downloadFile(response.data, fileName);
        snackbarMsg = "Client chart exported successfully.";
      } else {
        snackbarMsg =
          response?.message ??
          response?.data?.message ??
          "Oops! Something went wrong. Please try again later.";
      }
      this.$store.commit("uxModule/setSnackbarMsg", snackbarMsg);
      this.$store.commit("uxModule/setShowSnackbar", true);
      this.$store.commit("uxModule/setShowLoader", false);
    },
  },
};
</script>
